import { Box, GelTheme } from '@onegov/react-component-library';
import React from 'react';
import styled from 'styled-components';

const Typography = styled('span')`
  font-weight: ${(props) => (props.fontWeight ? GelTheme.fontWeight(props.fontWeight) : undefined)};
  font-size: ${(props) => (props.fontSize ? GelTheme.fontSize(props.fontSize) : undefined)};
  color: ${(props) => (props.color ? GelTheme.color(props.color) : undefined)};
`;

const Label = styled(Typography)`
  display: block;
  margin-bottom: ${GelTheme.spacing(0.5)};
`;

const Value = styled(Typography)`
  display: inline-block;
`;

/**
 * A simple pairing of a label and a value with the correct font sizes, weights, and spacing.
 */
export const LabelledValue = ({ label, value }) => {
  return (
    <Box as="p" my={[0.5, 1]}>
      <Label fontWeight="bold">{label}</Label>
      <Value>{value}</Value>
    </Box>
  );
};
